import { render, staticRenderFns } from "./MmfPagination.vue?vue&type=template&id=25558a9e&"
import script from "./MmfPagination.vue?vue&type=script&lang=js&"
export * from "./MmfPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports